const dict = {
  uk: {
    currency: 'грн',
    stats: {
      hoursWorked: 'Відпрацьовано годин',
      forPeriod: 'за {{month}} {{year}}',
      currentMonth: 'поточний місяць',
      netEarnings: 'Чистий дохід',
      earnedBreakdown: 'Зароблено: {{earned}} грн | Штрафи: -{{penalties}} грн',
      forConductedLessons: 'за проведені уроки',
      penalties: 'Штрафи',
      activePenalties: '{{count}} активних штрафів',
      payoutDates: 'Дати виплат',
      advance: 'Аванс:',
      salary: 'Зарплата:',
      advanceDay: '15 числа',
      salaryDay: 'останній день місяця',
    },
    rates: {
      title: 'Деталізація ставки',
      teacherLevelTitle: 'Рівень викладача',
      individual: 'Індивідуальне заняття',
      group: 'Групове заняття',
      club: 'Заняття клубу',
      cancelledOnTime: 'Заняття скасовані учнем вчасно',
      cancelledLate: 'Заняття скасовані учнем невчасно',
      noCompensation: 'без компенсації',
      compensationPercent: 'компенсація {{percent}}%',
    },
    history: {
      title: 'Історія занять',
      loading: 'Завантаження...',
      empty: 'Поки що немає історії занять',
      emptyMonth: 'Немає занять за цей місяць',
      lessonsCount: '{{count}} занять',
    },
    monthSummary: {
      hours: 'Годин',
      earned: 'Зароблено',
      penalties: 'Штрафи',
      net: 'Чистий дохід',
    },
    paymentStatus: {
      currentMonth: 'Поточний місяць',
      paid: 'Виплачено',
      partial: 'Частково виплачено',
      noLessons: 'Немає занять',
      pending: 'Очікує виплати',
    },
    receipt: {
      button: 'Квитанція',
      tooltip: 'Переглянути квитанцію',
      modalTitle: 'Квитанція про виплату',
      alt: 'Квитанція',
    },
    table: {
      dateTime: 'Дата/Час',
      studentGroup: 'Студент/Група',
      duration: 'Тривалість',
      status: 'Статус',
      amount: 'Сума',
    },
    lessonType: {
      individual: 'Індивідуальний',
      group: 'Груповий',
      club: 'Клуб',
      consultation: 'Консультація',
    },
    lessonStatus: {
      paid: 'Оплачено',
      free: 'Безкоштовно',
      cancelledLate: 'Скасовано невчасно',
      cancelledLateNote: 'менше ніж за 4 год · 50%',
      cancelledOnTime: 'Скасовано вчасно',
      cancelledOnTimeNote: 'Без компенсації',
      teacherNoShow: 'Неявка вчителя',
      teacherNoShowNote: 'Штраф нараховано',
      teacherShort: 'Неповний урок',
      teacherShortNote: 'Без нарахування · без штрафу',
      bothNoShow: 'Обопільна неявка',
      bothNoShowNote: 'Штраф нараховано',
      scheduled: 'Заплановано',
      vacationSkip: 'Канікули',
      frozen: 'Заморожено',
      studentNoShow: 'Неявка учня',
      studentNoShowNote: 'Компенсація нарахована',
    },
    presence: {
      showTooltip: 'Показати час входів і виходів',
      timeLabel: 'Час',
      loading: 'Завантаження...',
      noData: 'Немає даних',
      teacher: 'Вчитель',
      student: 'Учень',
      joined: 'приєднався до уроку',
      left: 'вийшов з уроку',
    },
    durationMinutes: '{{count}} хв',
    balanceLabel: 'Баланс',
    topUp: 'Поповнити',
    transactionHistory: 'Історія транзакцій',
    noTransactions: 'Немає транзакцій',
    txPending: 'Очікує',
    txRejected: 'Відхилено',
    txFree: 'Безкоштовно',
  },
  en: {
    currency: 'UAH',
    stats: {
      hoursWorked: 'Hours worked',
      forPeriod: 'for {{month}} {{year}}',
      currentMonth: 'current month',
      netEarnings: 'Net earnings',
      earnedBreakdown: 'Earned: {{earned}} UAH | Penalties: -{{penalties}} UAH',
      forConductedLessons: 'for conducted lessons',
      penalties: 'Penalties',
      activePenalties: '{{count}} active penalties',
      payoutDates: 'Payout dates',
      advance: 'Advance:',
      salary: 'Salary:',
      advanceDay: '15th of the month',
      salaryDay: 'last day of the month',
    },
    rates: {
      title: 'Rate details',
      teacherLevelTitle: 'Teacher level',
      individual: 'Individual lesson',
      group: 'Group lesson',
      club: 'Club lesson',
      cancelledOnTime: 'Lessons cancelled on time by student',
      cancelledLate: 'Lessons cancelled late by student',
      noCompensation: 'no compensation',
      compensationPercent: '{{percent}}% compensation',
    },
    history: {
      title: 'Lesson history',
      loading: 'Loading...',
      empty: 'No lesson history yet',
      emptyMonth: 'No lessons this month',
      lessonsCount: '{{count}} lessons',
    },
    monthSummary: {
      hours: 'Hours',
      earned: 'Earned',
      penalties: 'Penalties',
      net: 'Net earnings',
    },
    paymentStatus: {
      currentMonth: 'Current month',
      paid: 'Paid',
      partial: 'Partially paid',
      noLessons: 'No lessons',
      pending: 'Awaiting payout',
    },
    receipt: {
      button: 'Receipt',
      tooltip: 'View receipt',
      modalTitle: 'Payout receipt',
      alt: 'Receipt',
    },
    table: {
      dateTime: 'Date/Time',
      studentGroup: 'Student/Group',
      duration: 'Duration',
      status: 'Status',
      amount: 'Amount',
    },
    lessonType: {
      individual: 'Individual',
      group: 'Group',
      club: 'Club',
      consultation: 'Consultation',
    },
    lessonStatus: {
      paid: 'Paid',
      free: 'Free',
      cancelledLate: 'Cancelled late',
      cancelledLateNote: 'less than 4 h · 50%',
      cancelledOnTime: 'Cancelled on time',
      cancelledOnTimeNote: 'No compensation',
      teacherNoShow: 'Teacher no-show',
      teacherNoShowNote: 'Penalty charged',
      teacherShort: 'Short lesson',
      teacherShortNote: 'No earnings · no penalty',
      bothNoShow: 'Both no-show',
      bothNoShowNote: 'Penalty charged',
      scheduled: 'Scheduled',
      vacationSkip: 'Vacation',
      frozen: 'Frozen',
      studentNoShow: 'Student no-show',
      studentNoShowNote: 'Compensation awarded',
    },
    presence: {
      showTooltip: 'Show join/leave times',
      timeLabel: 'Time',
      loading: 'Loading...',
      noData: 'No data',
      teacher: 'Teacher',
      student: 'Student',
      joined: 'joined the lesson',
      left: 'left the lesson',
    },
    durationMinutes: '{{count}} min',
    balanceLabel: 'Balance',
    topUp: 'Top up',
    transactionHistory: 'Transaction history',
    noTransactions: 'No transactions',
    txPending: 'Pending',
    txRejected: 'Rejected',
    txFree: 'Free',
  },
};

export default dict;
